import { requireField } from './validators';

export default class Enrolment {
  constructor(data = {}) {
    requireField(data.programme, 'enrolment.programme');
    requireField(data.startDate, 'enrolment.startDate');

    this.id = data.id || `enr-${Math.random().toString(36).slice(2, 9)}`;
    this.programme = data.programme;
    this.startDate = data.startDate;
    this.endDate = data.endDate || null;
    this.days = data.days || [];
  }

  toJSON() {
    return { ...this };
  }
}
